export default [
	{
		path: "/admin/pros/profile/:providerId",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminProfile",
		mui: true,
	},
];
